import React from 'react'
import ClosingBalanceTable from './closingBalnaceTable';
import RecentGenerate from "./RecentGenerate"
import Loading from 'Components/MUI_components/loading';


function ClosingBalanceSummery(props) {
    const {
        loading,
        initLoad,
        closingBalance,
        status,
        recentGenerate,
        lastDate
    } = props
    return (
        <div className="mt mb">
            {loading ? (
                <Loading height={100} text="Loading.." />
            ) : !initLoad && (
                <div>
                    {!status.closingBalanceAvailable ? (
                        <>
                        <div >
                            <RecentGenerate
                            recentGenerate={recentGenerate}
                            lastDate={lastDate}
                            />
                        </div>
                        </>
                    ) : (
                        <ClosingBalanceTable 
                            closingBalance={closingBalance}
                        />
                    )}
                   

                </div>
            )}
        </div>
    )
}

export default ClosingBalanceSummery;